import React, { FC } from 'react';
import { Collapse, TableCell, TableRow } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';
import { ButtonClassNames } from '../../../../models/Common';
import { TableBodyCell } from '../../../../models/CustomTable';

export const CollapsibleRow: FC<TableBodyCell> = ({
  label,
  bodyCells,
  isDisabled,
  history,
  isCollapsibleButton,
  isVerticalAlignCells,
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <TableRow onClick={() => setOpen(!open)} className="collapsible">
        {label && <TableCell className="collapsible">{label}</TableCell>}
        {bodyCells.map((cell, index) => {
          return (
            <TableCell
              key={`${cell}${index + 1}`}
              className={`${isDisabled ? 'disabled collapsible' : 'collapsible'} ${
                isVerticalAlignCells ? 'vertical-align-cells' : ''
              }`}
            >
              {cell}
            </TableCell>
          );
        })}
        {isCollapsibleButton && (
          <TableCell className="collapsible">
            <CustomMUIButton
              label={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              handleClick={() => setOpen(!open)}
              className={ButtonClassNames.Icon}
            />
          </TableCell>
        )}
      </TableRow>
      <TableRow onClick={() => setOpen(!open)} className="collapsible">
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {history && history}
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
